/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Never_DoneInputs */

const en_us2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never done`)
};

const pt_br2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca feito`)
};

const es_419_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca hecho`)
};

const pt_pt2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca feito`)
};

const fr_fr2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jamais fait`)
};

const de_de2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nie gemacht`)
};

const it_it2_swap_never_done = /** @type {(inputs: Swap_Never_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mai fatto`)
};

/**
* | output |
* | --- |
* | "Never done" |
*
* @param {Swap_Never_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_never_done = /** @type {((inputs?: Swap_Never_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Never_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_never_done(inputs)
	if (locale === "es-419") return es_419_swap_never_done(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_never_done(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_never_done(inputs)
	if (locale === "de-DE") return de_de2_swap_never_done(inputs)
	if (locale === "it-IT") return it_it2_swap_never_done(inputs)
	return en_us2_swap_never_done(inputs)
});
export { swap_never_done as "swap.never_done" }